<template>
  <v-app class="v-app">
    <link href='https://fonts.googleapis.com/css?family=Montserrat' rel='stylesheet'/>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script setup>
import { useStore } from 'vuex'
import axios from 'axios'

const store = useStore()

console.log(store.getters.API)
axios.get(`${store.getters.API}/get_models`).then(res => { // Get models from API
  store.commit('models', Object.keys(res.data))
})
</script>
